import { component } from 'picoapp'

class LoopingVideo {

  constructor(node, ctx) {
    // bindings
    this.videoCanPlay = this.videoCanPlay.bind(this)

    // selectors
    this._node = node
    this._videos = this._node.querySelectorAll('video')

    // event listeners
    this._videos.forEach((el) => {
      let self = this
      el.addEventListener('canplay', this.videoCanPlay)
      setTimeout(() => {
        self.forceCanPlay(el)
      }, 1500)
    })

    // unmount
    return this.unmount.bind(this)
  }

  //
  // Can play
  //
  videoCanPlay(e) {
    let el = e.currentTarget
    if (el.classList.contains('can-play') === false) {
      el.classList.add('can-play')
    }
  }

  //
  // Force can play
  //
  forceCanPlay(elm) {
    if (elm.classList.contains('can-play') === false) {
      elm.classList.add('can-play')
    }
  }

  //
  // Unmount.
  //
  unmount() {
    this._videos.forEach((el) => el.removeEventListener('canplay', this.videoCanPlay))
  }
}

export default component((node, ctx) => new LoopingVideo(node, ctx))
